import React from "react";

// Sample-from-marc-photo gesture, lifted out of App so any palette UI
// can begin a pick without prop-drilling. ReferencePhoto's pointer
// listeners are wired at App level.
//
// The picker is "live" — popover stays open, hover updates onPreview
// repeatedly, click commits via onPick. The session ends on
// `endEyedropper()` (toggle off) or Escape (which fires the registered
// onCancel so the caller can reset its own UI state).
//
// Default value is a no-op so consumers never crash if the provider is
// missing (e.g. on the gallery/admin pages, where there's no marc photo
// to sample from). The Edit Color UI hides the eyedropper button when
// `available` is false.
const EyedropperContext = React.createContext({
  available: false,
  active: false,
  beginEyedropper: () => {},
  endEyedropper: () => {},
});

export function EyedropperProvider({
  children,
  beginEyedropper,
  endEyedropper,
  active = false,
}) {
  const value = React.useMemo(
    () => ({ available: true, active, beginEyedropper, endEyedropper }),
    [active, beginEyedropper, endEyedropper],
  );
  return (
    <EyedropperContext.Provider value={value}>
      {children}
    </EyedropperContext.Provider>
  );
}

export function useEyedropper() {
  return React.useContext(EyedropperContext);
}
